import { render, staticRenderFns } from "./CardInformacoesTitulo.vue?vue&type=template&id=299bf995"
import script from "./CardInformacoesTitulo.vue?vue&type=script&lang=js"
export * from "./CardInformacoesTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports